import { render, staticRenderFns } from "./Soporte.vue?vue&type=template&id=a7f59476&scoped=true"
import script from "./Soporte.vue?vue&type=script&lang=js"
export * from "./Soporte.vue?vue&type=script&lang=js"
import style0 from "./Soporte.vue?vue&type=style&index=0&id=a7f59476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7f59476",
  null
  
)

export default component.exports